(function () {
    'use strict';

    // Processes Enter Key commands on input controls. 

    // Usage Example:
    // <input type="text" st-enter-key="someFunction();" />

    angular
        .module('smartertoolsApp')
        .directive('stEnterKey', stEnterKeyDirective);

    function stEnterKeyDirective() {
        return function (scope, element, attrs) {
            element.bind('keydown keypress', onKeyDown);

            function onKeyDown(event) {
                const keyCode = event.which || event.keyCode;

                // If enter key is pressed
                if (keyCode === 13) {
                    scope.$apply(function () {
                        // Evaluate the expression
                        scope.$eval(attrs.stEnterKey);
                    });
                    event.preventDefault();
                }
            }
        };
    }

})();